/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header($body) {
    let $header;

    const init = function () {
        $header = $(".header");

        // Sticky header
        setStickyHeader();
        $(window).scroll(function () {
            setStickyHeader();
        });
    };

    init();

    function setStickyHeader() {
        if ($(window).scrollTop() > $header.height() / 2) {
            $body.addClass("header-sticky");
        } else {
            $body.removeClass("header-sticky");
        }
    }
}

